import {
  AppState,
  PlanType,
  SearchResultPlan,
  PlanResultsSearchSummary,
  SortOptions,
  PlanSNPType,
  Plan,
} from "../../@types";
import { getPlans, getPlan } from "../../api";
import {
  CONSTANTS as C,
  filterUndefinedOut,
  makePlanUrlPartForApi,
  logError,
} from "../../helpers";

export interface SPPStateProps {
  pageError: boolean;
  totalPlans: number;
  currentPage: Plan[];
  pageCount: number;
  currentPageIdx: number;
  loadingPlans: boolean;
}

export const requestSanctionedPlans = async (
  page = 0,
  scrollToTop = false,
  state: AppState,
  updatePageState: (state: Record<string, unknown>) => void
): Promise<void> => {
  if (!state.fips) return;

  try {
    updatePageState({ loadingPlans: true });
    let pendingPageState = { loadingPlans: false } as Partial<SPPStateProps>;

    const { fips, planType, year, zipcode: zip } = state;
    const plan_type =
      planType === PlanType.PDP ? PlanType.PDP : [PlanType.MA, PlanType.MAPD];

    const {
      plans,
      search_summary,
    }: {
      plans: SearchResultPlan[];
      search_summary: PlanResultsSearchSummary | undefined;
    } = await getPlans({
      fips,
      zip,
      page,
      plan_type,
      sort_order: SortOptions.MONTHLY_PREMIUM,
      year,
      snp_type: [
        PlanSNPType.SNP_TYPE_CHRONIC_OR_DISABLING,
        PlanSNPType.SNP_TYPE_DUAL_ELIGIBLE,
        PlanSNPType.SNP_TYPE_INSTITUTIONAL,
        PlanSNPType.SNP_TYPE_NOT_SNP,
      ],
      sanctioned_only: true,
    }).then(result => {
      let plans: SearchResultPlan[] = [];
      if (result) {
        plans = filterUndefinedOut<SearchResultPlan>(result.plans);
      }
      return { plans, search_summary: result?.search_summary };
    });

    pendingPageState.currentPageIdx = page;

    const pageData = await Promise.all(
      plans.map((srPlan: SearchResultPlan) => {
        const url = makePlanUrlPartForApi(srPlan);

        return getPlan(url);
      })
    ).then(plans => filterUndefinedOut<Plan>(plans));

    pendingPageState.currentPage = pageData;

    if (page === 0) {
      const total = search_summary?.sanctioned ?? 0;

      pendingPageState = {
        ...pendingPageState,
        totalPlans: total,
        pageCount: Math.ceil(total / C.apiVars.count),
        currentPageIdx: 0,
      };
    }

    if (scrollToTop) {
      window.scrollTo(0, 0);
    }
    updatePageState(pendingPageState);
  } catch (e) {
    updatePageState({ pageError: true, loadingPlans: false });
    logError("Failed to retrieve sanctioned plans", e);
  }
};
